import axios from "axios";

//state
export var strategyActionState = {
  strategyActions: [],
  strategyAction: {},
  status_strategyAction: ""
};

//getters
export var strategyActionGetters = {
  //funciones para optener informacion del state
  getStrategyActions: state => state.strategyActions
};

//actions
export var strategyActionActions = {
  async getStrategyActions({ commit }) {
    commit("strategyAction_request");
    await this._vm.$http
      .get("/apache/rest_api/apache.strategic_action", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'name', 'description', 'date_start', 'date_end',('partner_id', ['id', 'name']),['promotion_ids', ['id', 'name']],['targeting_ids', ['id', 'name']],['lines_ids', ['id', 'name']]]"
        }
      })
      .then(res => {
        var strategyActions = res.data !== "" ?res.data : [] ;
        console.log("res.data from strategyActions ::::: ", res);
        commit("strategyAction_success", strategyActions);
        return res;
      })
      .catch(err => {
        commit("strategyAction_error");
        return err;
      });
  },
  async newStretegyAction({ commit, state }, strategyAction) {
    commit("partner_request");
    var {
      name,
      description,
      dateStart,
      dateEnd,
      lines_ids,
      stereotype_ids,
      promotion_id,
      stereotypesSelected,
      promotionSelected,
      linesSelected
    } = strategyAction;
    var formData = new FormData();
    var newStrategyAction = `{'name':'${name}','description': '${description}','date_start': '${dateStart}', 'date_end': '${dateEnd}', 'lines_ids': [${lines_ids}],'targeting_ids': [${stereotype_ids}],'promotion_ids': [${promotion_id}],'relational_fields': [('lines_ids', 'apache.content_line'), ('targeting_ids', 'apache.adset.targeting'),('promotion_ids', 'apache.promotion')]}`;

    formData.append("data", newStrategyAction);
    await this._vm.$http
      .post("/apache/rest_api/apache.strategic_action", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 201) {
          strategyAction.id = res.data.id;
          strategyAction.date_start = dateStart;
          strategyAction.date_end = dateEnd;
          strategyAction.targeting_ids = stereotypesSelected;
          strategyAction.lines_ids = linesSelected;
          strategyAction.promotion_ids = [promotionSelected];
          var strategyActions = state.strategyActions;
          strategyActions.push(strategyAction);
          commit("strategyAction_success", strategyActions);
          return strategyActions;
        } else {
          commit("strategyAction_error");
        }
      })
      .catch(err => {
        commit("strategyAction_error");
        return err;
      });
  },
  async editStretegyAction({ commit, state }, strategyAction) {
    commit("partner_request");
    var {
      id,
      name,
      description,
      dateStart,
      dateEnd,
      lines_ids,
      stereotype_ids,
      promotion_id,
      stereotypesSelected,
      linesSelected,
      promotionSelected
    } = strategyAction;
    var formData = new FormData();
    var newStrategyAction = `{'name':'${name}','description': '${description}','date_start': '${dateStart}', 'date_end': '${dateEnd}', 'lines_ids': [${lines_ids}],'targeting_ids': [${stereotype_ids}],'promotion_ids': [${promotion_id}],'relational_fields': [('lines_ids', 'apache.content_line'), ('targeting_ids', 'apache.adset.targeting'),('promotion_ids', 'apache.promotion')]}`;

    formData.append("data", newStrategyAction);
    await this._vm.$http
      .put(`/apache/rest_api/apache.strategic_action/`, formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          var index;
          strategyAction.id = id;
          strategyAction.name = name;
          strategyAction.description = description;
          strategyAction.date_start = dateStart;
          strategyAction.date_end = dateEnd;
          strategyAction.targeting_ids = stereotypesSelected;
          strategyAction.lines_ids = linesSelected;
          strategyAction.promotion_ids = (promotionSelected)?promotionSelected:[];
          var strategyActions = state.strategyActions;
          for (var i = 0; i < strategyActions.length; i++) {
            if (strategyActions[i].id == id) {
              index = i;
              strategyActions[i] = strategyAction;
              break;
            }
          }
          strategyActions.splice(index, 1);
          strategyActions.splice(index, 0, strategyAction);
          commit("strategyAction_success", strategyActions);

          return strategyActions;
        } else {
          commit("strategyAction_error");
        }
      })
      .catch(err => {
        commit("strategyAction_error");
        return err;
      });
  },
  async deleteStretegyAction({ commit, state }, id) {
    commit("partner_request");
    try {
      await this._vm.$http
        .delete(`/apache/rest_api/apache.strategic_action/${id}`, {
          headers: {
            "X-Odoo-dbfilter": "apachev1"
          }
        })
        .then(res => {
          if (res.status == 210) {
            var index;
            var strategyActions = state.strategyActions;
            for (var i = 0; i < strategyActions.length; i++) {
              if (strategyActions[i].id == id) {
                index = i;
                break;
              }
            }
            strategyActions.splice(index, 1);
            commit("strategyAction_success", strategyActions);

            return strategyActions;
          } else {
            commit("strategyAction_error");
          }
        })
        .catch(err => {
          commit("strategyAction_error");
          return err;
        });
    } catch (error) {
      console.log(error);
    }
  },
  async deleteStrategyActionsUtility({ commit, state }, id) {
    commit("partner_request");
    var index;
    var strategyActions = state.strategyActions;
    for (var i = 0; i < strategyActions.length; i++) {
      if (strategyActions[i].id == id) {
        index = i;
        break;
      }
    }
    strategyActions.splice(index, 1);
    commit("strategyAction_success", strategyActions);

    return strategyActions;
  }
};

//mutations

export var strategyActionMutations = {
  strategyAction_request(state) {
    state.status_strategyAction = "loading";
  },
  strategyAction_success(state, payload) {
    state.status_strategyAction = "success";
    state.strategyActions = payload;
  },
  strategyAction_error(state) {
    state.status_strategyActions = "error";
  }
};
